import { Routes, Route } from "react-router-dom";
import AppLayout from "@cloudscape-design/components/app-layout";
import TopNavigation from "@cloudscape-design/components/top-navigation";
import SideNavigation from "@cloudscape-design/components/side-navigation";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { checkAuth, getCurrentUser, logout } from "./auth";
import TicketListPage from "./pages/TicketListPage";
import TicketDetailPage from "./pages/TicketDetailPage";
import MetricsPage from "./pages/MetricsPage";
import DecisionLogPage from "./pages/DecisionLogPage";
import ReportsPage from "./pages/ReportsPage";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [navigationOpen, setNavigationOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<string | null>(null);

  useEffect(() => {
    const authed = checkAuth();
    if (authed) {
      setIsAuthenticated(true);
      setUser(getCurrentUser());
    }
  }, []);

  const activeHref = location.pathname;

  if (!isAuthenticated) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <p>Authenticating with Midway...</p>
      </div>
    );
  }

  return (
    <>
      <TopNavigation
        identity={{
          href: "/",
          title: "PIRT Triage Dashboard",
        }}
        utilities={[
          {
            type: "button",
            text: "Refresh",
            iconName: "refresh",
            onClick: () => window.location.reload(),
          },
          {
            type: "menu-dropdown",
            text: user || "folaok",
            iconName: "user-profile",
            items: [
              { id: "signout", text: "Sign out" },
            ],
            onItemClick: ({ detail }) => {
              if (detail.id === "signout") logout();
            },
          },
        ]}
      />
      <AppLayout
        navigationOpen={navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        navigation={
          <SideNavigation
            activeHref={activeHref}
            onFollow={(event) => {
              if (!event.detail.external) {
                event.preventDefault();
                navigate(event.detail.href);
              }
            }}
            items={[
              { type: "link", text: "Triage Queue", href: "/" },
              { type: "link", text: "Metrics", href: "/metrics" },
              { type: "link", text: "Reports", href: "/reports" },
              { type: "link", text: "Decision Log", href: "/decision-log" },
              { type: "divider" },
              { type: "link-group", text: "Quick Links", href: "#", items: [
                {
                  type: "link",
                  text: "SIM-T (WP Incident Mgmt)",
                  href: "https://t.corp.amazon.com/issues?q=%7B%22AND%22%3A%7B%22status%22%3A%7B%22OR%22%3A%5B%22Assigned%22%2C%22Work%20In%20Progress%22%5D%7D%2C%22assignedGroup%22%3A%22WP%20Incident%20Management%22%7D%7D",
                  external: true,
                },
                {
                  type: "link",
                  text: "Taskei (PCFE Room)",
                  href: "https://taskei.amazon.dev/rooms/7ec055e6-e7ae-41ce-8b75-600620586f07",
                  external: true,
                },
              ]},
            ]}
          />
        }
        content={
          <Routes>
            <Route path="/" element={<TicketListPage />} />
            <Route path="/tickets/:ticketId" element={<TicketDetailPage />} />
            <Route path="/metrics" element={<MetricsPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/decision-log" element={<DecisionLogPage />} />
          </Routes>
        }
        toolsHide={true}
      />
    </>
  );
}

export default App;
